import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks';
import { dismissAlert, extendSession } from 'store/sessionReducer';

const SessionAlertDialog = () => {
    const dispatch = useAppDispatch();
    const { showAlert, isExtending } = useAppSelector((state) => state.session);

    const handleExtend = () => {
        dispatch(extendSession());
    };

    const handleClose = () => {
        dispatch(dismissAlert());
    };

    return (
        <Dialog open={showAlert} onClose={handleClose} sx={{ zIndex: 99999 }}>
            <DialogTitle>세션 만료 경고</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    세션이 곧 만료됩니다. 계속 사용하시려면 세션을 연장해주세요.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit">
                    닫기
                </Button>
                <Button onClick={handleExtend} color="error" variant="contained" disabled={isExtending}>
                    {isExtending ? '연장 중...' : '연장하기'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionAlertDialog;
